import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Breadcrumb, FormDetailsItem, Table } from '../../common/components';
import { getWarrantyDict, getWarrantyOptions, deleteWarranty } from '../services/dictionary.service';

const TABLE_CONFIG = {
  columns: [
    {
      caption: 'Nazwa',
      dataField: 'name',
      sort: true,
    },
    {
      caption: 'Grupa',
      dataField: 'group.name',
      sort: true,
    },
    {
      caption: 'Cena',
      dataField: 'price',
      sort: true,
    },
    {
      caption: 'Rzeczywista cena',
      dataField: 'actualPrice',
      sort: true,
    },
  ],
  noItemsFoundText: 'Brak opcji dodatkowych',
  initialSort: {
    sortField: 'name',
    sortDirection: 'asc',
  },
  filterFields: 'name',
};

const COMPANY_GROUP_TABLE_CONFIG = {
  columns: [
    {
      caption: 'Grupa',
      dataField: 'name',
      sort: true,
    },
    {
      caption: 'Cena',
      dataField: 'price',
      sort: true,
    },
    {
      caption: 'Rzeczywista cena',
      dataField: 'actualPrice',
      sort: true,
    },
  ],
  noItemsFoundText: 'Brak cen dla grup',
  initialSort: {
    sortField: 'name',
    sortDirection: 'asc',
  },
  filterFields: 'name',
};

class WarrantyDetails extends PureComponent {
  state = {
    data: [],
    detailsData: {},
    totalCount: 0,
    isLoading: true,
  };

  id = this.props.match.params.id;

  getData = async (params) => {
    this.setState({
      isLoading: true,
    });

    const { data, totalCount } = await getWarrantyOptions(
      Object.assign(params, { dictWarrantyType: this.id }),
    );
    const detailsData = await getWarrantyDict(this.id);

    this.setState({
      data,
      totalCount,
      detailsData,
      isLoading: false,
    });
  };

  onRowClick = (ev) => {
    const { history } = this.props;
    const {
      currentTarget: { id },
    } = ev;
    history.push(`/dictionary/warranty-option-details/${this.id}/${id}`);
  }

  onCompanyGroupRowClick = (ev) => {
    const { history } = this.props;
    const { detailsData } = this.state;
    const {
      currentTarget: { id },
    } = ev;
    history.push({ pathname: `/dictionary/warranty-companyGroup-price-details/${this.id}/${id}`, state: detailsData.groups.map((group) => group.group.id) });
  };

  handleAdd = () => {
    const { history } = this.props;

    history.push(`/dictionary/warranty-option-dict/${this.id}`);
  }

  handleAddPrice = () => {
    const { history } = this.props;
    const { detailsData } = this.state;

    history.push({ pathname: `/dictionary/warranty-companyGroup-price/${this.id}`, state: detailsData.groups.map((group) => group.group.id) });
  }

  handleEdit = () => {
    const { history } = this.props;

    history.push(`/dictionary/warranty/${this.id}`);
  }

  handleDelete = async () => {
    const { history } = this.props;

    if (window.confirm('Jesteś pewien, ze chcesz usunąć rodzaj gwarancji?')) {
      await deleteWarranty(this.id);

      history.replace('/dictionary/warranties');
    }
  }

  render() {
    const {
      data,
      detailsData,
      isLoading,
      totalCount,
    } = this.state;

    return (
      <>
        <Breadcrumb>
          <div className="row no-gutters justify-content-end py-3">
            <button
              type="button"
              className="btn btn-outline-primary"
              onClick={this.handleAdd}
            >
              Dodaj opcję
            </button>
          </div>
        </Breadcrumb>
        <div className="content">
          <div className="card">
            <div className="card-header row no-gutters align-items-center justify-content-between">
              Szczegóły gwarancji

              <div>
                <button
                  type="button"
                  className="btn btn-outline-primary ml-3"
                  onClick={this.handleDelete}
                >
                  Usuń gwarancję
                </button>
                <button
                  type="button"
                  className="btn btn-outline-primary ml-3"
                  onClick={this.handleEdit}
                >
                  Edytuj gwarancję
                </button>
              </div>
            </div>
            <div className="card-body">
              <FormDetailsItem label="Nazwa" value={detailsData.name} />
              <FormDetailsItem label="Czas trwania" value={detailsData.duration} />
              <FormDetailsItem label="Limit km" value={detailsData.mileage_limit} />
              <FormDetailsItem label="Limit wieku pojazdu" value={detailsData.year_limit} />
              <FormDetailsItem label="Aktywny" value={detailsData.active ? 'Tak' : 'Nie'} />
            </div>
          </div>
        </div>
        <div className="content">
          <div className="card">
            <div className="card-header row no-gutters align-items-center justify-content-between">
              Lista cen dla grup klientów
              <div>
                <button
                  type="button"
                  className="btn btn-outline-primary ml-3"
                  onClick={this.handleAddPrice}
                >
                  Dodaj cene dla grupy
                </button>
              </div>
            </div>
            <Table
              config={COMPANY_GROUP_TABLE_CONFIG}
              items={ (detailsData.groups && detailsData.groups.map((companyGroup) => ({ ...companyGroup, name: companyGroup.group.name }))) || []}
              fetchData={this.getData}
              totalCount={totalCount}
              isLoading={isLoading}
              onRowClick={this.onCompanyGroupRowClick}
              pagination
            />
          </div>
        </div>
        <div className="content">
          <div className="card">
            <div className="card-header row no-gutters align-items-center justify-content-between">
              Lista opcji dla grup klientów
            </div>
            <Table
              config={TABLE_CONFIG}
              items={data}
              fetchData={this.getData}
              totalCount={totalCount}
              isLoading={isLoading}
              onRowClick={this.onRowClick}
              pagination
            />
          </div>
        </div>
      </>
    );
  }
}

WarrantyDetails.defaultProps = {};

WarrantyDetails.propTypes = {
  match: PropTypes.objectOf(PropTypes.shape).isRequired,
  history: PropTypes.objectOf(PropTypes.shape).isRequired,
};

export default withRouter(WarrantyDetails);
